export const WORKSPACE_TYPES = [
    "program",
    "web",
    "sql"
];

const PROGRAM_CHECKS = [
    { value: "stdout_exact", label: "STDOUT Equals" },
    { value: "stdout_contains", label: "STDOUT Contains" },
    { value: "stdout_regex", label: "STDOUT Regex" },
    { value: "stderr_exact", label: "STDERR Equals" },
    { value: "stderr_contains", label: "STDERR Contains" },
    { value: "exit_code", label: "Exit Code" },
    { value: "variable_equals", label: "Variable Equals" },
    { value: "variable_equals", label: "Variable Equals" },
    { value: "variable_type", label: "Variable Type" },
    { value: "variable_exists", label: "Variable Exists" },
    { value: "comment", label: "Comment" },
    { value: "array_list_equals", label: "List or Array Equals" },
    { value: "array_list_exists", label: "List or Array Exists" },
];

const WEB_CHECKS = [
    // HTML structure
    { value: "tag_exists", label: "Tag Exists" },
    { value: "tag_count", label: "Tag Count" },
    { value: "tag_with_class_exists", label: "Tag With Class Exists" },
    { value: "tag_with_id_exists", label: "Tag With ID Exists" },

    // Text / attributes
    { value: "text_exact", label: "Text Equals" },
    { value: "attribute_equals", label: "Attribute Equals" },

    // CSS
    { value: "css_property_equals", label: "CSS Property Equals" },
    { value: "selector_matches", label: "Selector Matches" },

    // JavaScript
    { value: "js_variable_equals", label: "JavaScript Variable Equals" },
    { value: "js_expression_equals", label: "JavaScript Expression Equals" },
    { value: "event_fired", label: "Event Fired" },
    { value: "console_exact", label: "Console Equals" },
    { value: "console_contains", label: "Console Contains" },
    { value: "local_storage_equals", label: "Local Storage Equals" },
    { value: "session_storage_equals", label: "Session Storage Equals" }
];

const SQL_CHECKS = [
    { value: "row_count", label: "Row Count" },
    { value: "rows_exact", label: "Rows Exact" },
    { value: "columns_exact", label: "Columns Exact" },
    { value: "cell_equals", label: "Cell Equals" }
];

const PROGRAM_TEMPLATES = [
    {
        value: "python_beginner",
        label: "Python Beginner",
        slots: ["main"],
        language: "python",
        checks: PROGRAM_CHECKS
    },
    {
        value: "java_beginner",
        label: "Java Beginner",
        slots: ["main"],
        language: "java",
        checks: PROGRAM_CHECKS
    },
    {
        value: "cpp_beginner",
        label: "C++ Beginner",
        slots: ["main"],
        language: "cpp",
        checks: PROGRAM_CHECKS
    }
];

const WEB_TEMPLATES = [
    {
        value: "web_html",
        label: "HTML",
        slots: ["html"],
        checks: WEB_CHECKS
    },
    {
        value: "web_html_css",
        label: "HTML + CSS",
        slots: ["html", "css"],
        checks: WEB_CHECKS
    },
    {
        value: "web_html_css_js",
        label: "HTML + CSS + JavaScript",
        slots: ["html", "css", "js"],
        checks: WEB_CHECKS
    }
];

const SQL_TEMPLATES = [
    {
        value: "sqlite_basic",
        label: "SQLite",
        slots: ["sql"],
        checks: SQL_CHECKS
    }
];

export const WORKSPACE_TEMPLATES = {
    program: PROGRAM_TEMPLATES,
    web: WEB_TEMPLATES,
    sql: SQL_TEMPLATES
};

export const CHECKS_BY_TEMPLATE = {
    python_beginner: PROGRAM_CHECKS,
    java_beginner: PROGRAM_CHECKS,
    cpp_beginner: PROGRAM_CHECKS,

    web_html: WEB_CHECKS,
    web_html_css: WEB_CHECKS,
    web_html_css_js: WEB_CHECKS,

    sqlite_basic: SQL_CHECKS
};